import { render, staticRenderFns } from "./assetBankBind.vue?vue&type=template&id=47e67151&scoped=true&"
import script from "./assetBankBind.vue?vue&type=script&lang=js&"
export * from "./assetBankBind.vue?vue&type=script&lang=js&"
import style0 from "./assetBankBind.vue?vue&type=style&index=0&id=47e67151&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e67151",
  null
  
)

export default component.exports